module.exports = __webpack_public_path__ + "img/pl.f7adaa94.svg";